import {
	DEPRECATED_STATUS_EDITOR_REDO,
	PHOTOSHOOT_TYPE_SERVICE,
	SERVICE_REQUESTS,
	STATUS_ADMIN_HOLD,
	STATUS_EDITOR_UPLOAD,
	STATUS_FINDING_EDIT_TECHNICIAN,
	STATUS_FINDING_PREFERRED_TECHNICIAN,
	STATUS_FINDING_TECHNICIAN,
	STATUS_LIVE,
	STATUS_PRE_ORDER,
	STATUS_REVIEW,
	STATUS_STANDBY,
	STATUS_TECHNICIAN_UPLOAD
} from '../../../../../utils/Config/Constants';
import moment from 'moment-timezone';
import { SERVICE_REQUEST_TABLE_TYPE, SERVICES_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';

export const ADMIN_TASK_TABS = {
	additionalProcessingRequired: {
		value: 'additionalProcessingRequired',
		text: 're-edits (DEPRECATED)',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 're-edits',
		query: {
			op_and: [{ customerServiceAgentId: { op_eq: null } }, { status: { op_eq: DEPRECATED_STATUS_EDITOR_REDO } }]
		}
	} as AdminTaskTabType,
	administrativeHold: {
		value: 'administrativeHold',
		text: 'administrative hold',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'admin-hold',
		query: {
			op_and: [{ customerServiceAgentId: { op_eq: null } }, { status: { op_eq: STATUS_ADMIN_HOLD } }]
		}
	} as AdminTaskTabType,
	awaitingApproval: {
		value: 'awaitingApproval',
		text: 'needs admin approval',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'admin-approval',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{
					status: STATUS_REVIEW
				}
			]
		}
	} as AdminTaskTabType,
	claimedServices: {
		value: 'claimedServices',
		text: 'claimed services',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'claimed',
		query: {
			customerServiceAgentId: { op_ne: null }
		}
	} as AdminTaskTabType,
	incompleteFloorPlans: {
		value: 'incompleteFloorPlans',
		text: 'incomplete floor plans',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'incomplete-floor-plans',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{ op_or: [{ cubiCasaOrderId: { op_eq: null } }, { cubiCasaOrderId: { op_eq: '' } }] },
				{ op_or: [{ cubiCasaModelId: { op_eq: null } }, { cubiCasaModelId: { op_eq: '' } }] },
				{ includesFloorplan: { op_eq: true } },
				{
					serviceDate: {
						op_lte: moment()
					}
				},
				{
					status: {
						op_ne: STATUS_STANDBY
					}
				}
			]
		}
	} as AdminTaskTabType,
	incompleteMatterports: {
		value: 'incompleteMatterports',
		text: 'incomplete matterports',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'incomplete-matterports',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{ includesMatterport: { op_eq: true } },
				{ matterportModelId: { op_eq: null } },
				{
					serviceDate: {
						op_lte: moment()
					}
				},
				{
					status: {
						op_ne: STATUS_STANDBY
					}
				}
			]
		}
	} as AdminTaskTabType,
	lateEditorUpload: {
		value: 'lateEditorUpload',
		text: 'late editor upload',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'late-editor-upload',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{ status: { op_eq: STATUS_EDITOR_UPLOAD } },
				{
					serviceDate: {
						op_lte: moment().subtract(16, 'hours')
					}
				}
			]
		}
	} as AdminTaskTabType,
	pendingInitialApproval: {
		value: 'pendingInitialApproval',
		text: 'initial approval',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'initial-approval',
		query: {
			op_and: [{ customerServiceAgentId: { op_eq: null } }, { status: { op_eq: STATUS_PRE_ORDER } }]
		}
	} as AdminTaskTabType,
	schedulingNeeded: {
		value: 'schedulingNeeded',
		text: 'no tech after 24hr',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'scheduling-needed',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{
					op_or: [
						{
							status: { op_eq: STATUS_FINDING_PREFERRED_TECHNICIAN }
						},
						{
							status: { op_eq: STATUS_FINDING_TECHNICIAN }
						}
					]
				},
				{
					createdAt: {
						op_lte: moment().subtract(1, 'day')
					}
				}
			]
		}
	} as AdminTaskTabType,
	schedulingPreferredTechnician: {
		value: 'schedulingPreferredTechnician',
		text: 'awaiting requested technician acceptance',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'preferred-acceptance',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{
					status: { op_eq: STATUS_FINDING_PREFERRED_TECHNICIAN }
				},
				{
					type: { op_eq: PHOTOSHOOT_TYPE_SERVICE }
				},
				{
					photographerId: {
						op_eq: null
					}
				}
			]
		}
	} as AdminTaskTabType,
	servicesAwaitingEditorAcceptance: {
		value: 'servicesAwaitingEditorAcceptance',
		text: 'services awaiting editor acceptance',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'awaiting-editor',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{
					status: { op_eq: STATUS_FINDING_EDIT_TECHNICIAN }
				}
			]
		}
	} as AdminTaskTabType,
	serviceRequestsAwaitingTechnicianAcceptance: {
		value: 'serviceRequestsAwaitingTechnicianAcceptance',
		text: 'awaiting editor acceptance',
		tableType: SERVICE_REQUEST_TABLE_TYPE,
		linkPath: '/service-request/',
		queryParam: 'sr-awaiting-editor',
		query: {
			status: { op_eq: SERVICE_REQUESTS.status.awaitingAcceptance }
		}
	} as AdminTaskTabType,
	serviceRequestsAwaitingRequestApproval: {
		value: 'serviceRequestsAwaitingRequestApproval',
		text: 'approve agent service requests',
		tableType: SERVICE_REQUEST_TABLE_TYPE,
		linkPath: '/service-request/',
		queryParam: 'sr-approve',
		query: {
			status: { op_eq: SERVICE_REQUESTS.status.awaitingRequestApproval }
		}
	} as AdminTaskTabType,
	serviceRequestsAwaitingReview: {
		value: 'serviceRequestsAwaitingReview',
		text: 'service requests review',
		tableType: SERVICE_REQUEST_TABLE_TYPE,
		linkPath: '/service-request/',
		queryParam: 'sr-review',
		query: {
			status: { op_eq: SERVICE_REQUESTS.status.awaitingAdminApproval }
		}
	} as AdminTaskTabType,
	upcomingWithoutTechnician: {
		value: 'upcomingWithoutTechnician',
		text: 'manual scheduling needed',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'manual-scheduling-needed',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{ type: { op_eq: PHOTOSHOOT_TYPE_SERVICE } },
				{ photographerId: { op_eq: null } },
				{ status: { op_ne: STATUS_STANDBY } },
				{
					serviceDate: {
						op_lte: moment().add(36, 'hours')
					}
				}
			]
		}
	} as AdminTaskTabType,
	uploadNeeded: {
		value: 'uploadNeeded',
		text: 'technician upload needed',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'tech-upload-needed',
		query: {
			op_and: [
				{ customerServiceAgentId: { op_eq: null } },
				{ status: { op_eq: STATUS_TECHNICIAN_UPLOAD } },
				{
					serviceDate: {
						op_lte: moment()
					}
				}
			]
		}
	} as AdminTaskTabType,
	waitingForCompletion: {
		value: 'waitingForCompletion',
		text: 'awaiting completion',
		tableType: SERVICES_TABLE_TYPE,
		linkPath: '/service/',
		queryParam: 'awaiting-completion',
		query: {
			op_and: [{ customerServiceAgentId: { op_eq: null } }, { status: { op_eq: STATUS_LIVE } }, { isAdminApproved: { op_eq: false } }]
		}
	} as AdminTaskTabType
};
export const TABS = (): AdminTaskTabType[] => {
	return [
		ADMIN_TASK_TABS.additionalProcessingRequired,
		ADMIN_TASK_TABS.administrativeHold,
		ADMIN_TASK_TABS.awaitingApproval,
		ADMIN_TASK_TABS.claimedServices,
		ADMIN_TASK_TABS.incompleteFloorPlans,
		ADMIN_TASK_TABS.incompleteMatterports,
		ADMIN_TASK_TABS.lateEditorUpload,
		ADMIN_TASK_TABS.pendingInitialApproval,
		ADMIN_TASK_TABS.schedulingNeeded,
		ADMIN_TASK_TABS.schedulingPreferredTechnician,
		ADMIN_TASK_TABS.servicesAwaitingEditorAcceptance,
		ADMIN_TASK_TABS.serviceRequestsAwaitingTechnicianAcceptance,
		ADMIN_TASK_TABS.serviceRequestsAwaitingRequestApproval,
		ADMIN_TASK_TABS.serviceRequestsAwaitingReview,
		ADMIN_TASK_TABS.upcomingWithoutTechnician,
		ADMIN_TASK_TABS.uploadNeeded,
		ADMIN_TASK_TABS.waitingForCompletion
	];
};
